import $ from 'jquery';
import Selectize from '@selectize/selectize/dist/js/selectize';

Selectize.defaults.respect_word_boundaries = false;

window.$ = $;
window.jQuery = $;
window.Selectize = Selectize;

window.$param = (...args) => (
  $.param(...args).replace(/%20/g, '+')
);

// NOTE: Cannot use import because it seems to be moved up, above where we
// define window.$.
require('jquery-ujs');
require('linkify-jquery');
require('ab-datepicker/js/datepicker');
require('selectize-plugin-a11y');

if (typeof window.timecopFreeze === 'function') {
  $(window.timecopFreeze);
}
